import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'serviceJob/';

export function useServiceJobFilter({
	filterRequest,
	pageSize = 25,
	sort = 'completedOn',
	sortDescending = true,
	enabled = true,
	refetchOnWindowFocus = false,
	expand = 'contact',
}: {
	filterRequest: Api.IServiceJobFilterRequest;
	pageSize?: number;
	sort?: 'completedOn' | 'jobNumber' | 'jobStatus';
	sortDescending?: boolean;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	expand?: string;
}) {
	const userSession = useUserSession();

	return useInfiniteQuery<Api.IPagedCollection<Api.IServiceJob>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IServiceJob>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageSize, pageToken: pageParam, sort, sortDescending, expand },
					urlPath: 'ServiceJob/filter',
				}),
				'POST',
				filterRequest
			);
		},
		refetchOnWindowFocus,
		queryKey: [BASE_QUERY_KEY, filterRequest, pageSize, sort, sortDescending, expand],
		initialPageParam: '',
	});
}

export const invalidateAllServiceJobFilters = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
